export default "__VITE_ASSET__DUcqzx7Z__"